/* eslint-disable */

import { isTagularEnabledForPage } from '../tagular';

const getTagular = (): Window['tagular'] | null =>
  window?.tagular ? window.tagular : null;

let eventsQueue: Record<string, unknown>[] = [];

const beam = () => {
  if (typeof window !== 'undefined') {
    window?.cohesion?.('ready', () => {
      eventsQueue.forEach(beam);
      eventsQueue = [];
    });
  }

  return (event: Record<string, unknown>): void => {
    if (!isTagularEnabledForPage()) {
      return;
    }

    const tagular = getTagular();

    if (!tagular) {
      eventsQueue.push(event);
      return;
    }

    // @ts-ignore
    tagular('beam', event['@type'] as string, event);
  };
};

export default beam();
